<!--
    课程分享-课程批量授权
    作用：第三步：新增校区代码，校区列表数据
    说明：版本3.0
-->
<template>
  <div class="step-wrapper">
    <div class="top-form">
      <div class="left">
        <el-input
          v-model="codeVal"
          style="width: 200px"
          placeholder="校区代码"
          size="medium"
          clearable
          @input="codeVal = codeVal.trim()"
        />
        <el-button
          type="primary"
          size="medium"
          class="add-btn"
          @click="addSchool"
        >+ 新 增</el-button
        >
      </div>
      <el-input
        v-model="searchVal"
        size="medium"
        placeholder="请输入内容进行搜索"
        style="width: 500px"
        clearable
      >
        <el-select
          slot="prepend"
          v-model="selectVal"
          style="width: 130px"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in optionVals"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          slot="append"
          @click="handlerSearch">搜索</el-button>
      </el-input>
    </div>
    <el-table
      v-loading="isLoading"
      ref="table"
      :data="list"
      :height="tableHeight"
      class="table-demo"
      row-key="id"
      fit
      style="width: 100%"
    >
      <el-table-column
        v-for="(item, index) in tableHead"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        align="center"
      />
      <el-table-column
        :prop="authType==='1'?'authAccountNum':'authCount'"
        :label="authType==='1'?'授权账号数':'授权次数'"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="{row}">
          <el-button
            v-if="authType==='1'"
            size="small"
            type="success"
            plain
            @click="handlerAuthAccount(row)">授权账号</el-button>
          <el-button
            v-else
            size="small"
            type="success"
            plain
            @click="handlerAuthCount(row)">授权次数</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      class="pagination-demo"
      @current-change="getList()"
    />
    <div class="bottom-btns">
      <el-button @click="lastStep">上一步</el-button>
      <el-button
        type="primary"
        @click="nextStep">下一步</el-button>
    </div>
    <!-- 授权账号 -->
    <account-dialog
      v-if="showAccountDialog"
      :row="curRow"
      :visible.sync="showAccountDialog"
      @close-dialog="showAccountDialog = false"
      @change-data="changeList" />
    <!-- 授权次数 -->
    <num-dialog
      v-if="showNumDialog"
      :row="curRow"
      :visible.sync="showNumDialog"
      @close-dialog="showNumDialog = false"
      @change-data="changeList" />
  </div>
</template>
<script>
import { fetchAuthSchool, createAuthSchool } from '@/api/courseOn';
import accountDialog from './accountDialog';
import numDialog from './numDialog.vue';

export default {
  name: 'ThreeStep',
  components: {
    accountDialog,
    numDialog,
  },
  props: {
    authType: String,
  },
  data() {
    return {
      showAccountDialog: false, // 授权账号弹窗
      showNumDialog: false, // 授权次数窗口
      codeVal: '',
      searchVal: '',
      selectVal: 'like[search_clients_name]',
      list: [],
      total: 0,
      isLoading: false,
      curRow: {},
      tableHeight: window.innerHeight - 250,
      selectionVal: [], // 授权账号
      listQuery: {
        // 列表请求参数
        page: 1,
        per_page: 15,
      },
      optionVals: [
        {
          label: '校区名称',
          value: 'like[search_clients_name]',
        },
        {
          label: '校区代码',
          value: 'like[search_clients_code]',
        },
        {
          label: '校长名称',
          value: 'like[search_master_user_name]',
        },
        {
          label: '校长手机号',
          value: 'like[search_master_user_phone]',
        },
      ],
      tableHead: [
        {
          label: '校区名称',
          prop: 'search_clients_name',
        },
        {
          label: '校区代码',
          prop: 'search_clients_code',
        },
        {
          label: '校长名称',
          prop: 'search_master_user_name',
        },
        {
          label: '校长手机号',
          prop: 'search_master_user_phone',
        },
        // {
        //   prop: 'staff_count',
        //   label: '授权账号数'
        // }
      ],
    };
  },
  mounted() {
    this.getList();
    window.onresize = () => {
      setTimeout(() => {
        this.tableHeight = document.body.clientHeight - 250;
      }, 500);
    };
  },
  methods: {
    // 获取学校列表
    getList() {
      this.isLoading = true;
      fetchAuthSchool(this.$store.state.choicesSchool.id, this.listQuery).then(
        (res) => {
          this.list = res.items;
          this.changeList();
          this.total = res.meta.total;
          this.isLoading = false;
        },
      );
    },
    changeList() {
      const newArr = [];
      if (this.authType === '1') {
        this.list.forEach((item) => {
          const filter = this.$store.state.accountAuth.filter(v => item.search_clients_id === v.id);
          if (filter.length) {
            newArr.push({
              ...item,
              authAccountNum: filter[0].staff_id_list.length,
            });
          } else {
            newArr.push({
              ...item,
              authAccountNum: 0,
            });
          }
        });
      } else {
        this.list.forEach((item) => {
          const filter = this.$store.state.accountAuth.filter(v => item.search_clients_id === v.id);
          if (filter.length) {
            newArr.push({
              ...item,
              authCount: filter[0].auth_number,
            });
          } else {
            newArr.push({
              ...item,
              authCount: 0,
            });
          }
        });
      }

      this.list = newArr;
    },
    // 新增校区
    addSchool() {
      if (this.codeVal) {
        createAuthSchool(this.$store.state.choicesSchool.id, this.codeVal).then((res) => {
          if (res.status_code === 200) {
            this.$message.success('新增校区成功！');
            this.listQuery.page = 1;
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning('校区代码不能为空！');
      }
    },
    // 搜索校区
    handlerSearch() {
      this.listQuery = {
        page: 1,
        per_page: 15,
      };
      this.listQuery[this.selectVal] = this.searchVal;
      this.getList();
    },
    // 授权账号弹窗
    handlerAuthAccount(row) {
      this.curRow = row;
      this.showAccountDialog = true;
    },
    // 授权次数窗口
    handlerAuthCount(row) {
      this.curRow = row;
      this.showNumDialog = true;
    },
    lastStep() {
      this.$emit('lastStep');
    },
    nextStep() {
      if (!this.$store.state.accountAuth.length) {
        const text = this.authType === '1' ? '请选择授权账号！' : '请设置校区上课次数！';
        this.$message.warning(text);
      } else {
        this.$emit('nextStep');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.step-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .top-form {
    display: flex;
    justify-content: space-between;
    .add-btn {
      margin-left: 10px;
    }
  }
  .table-demo{
    margin-top: 20px;
    flex:1
  }
  .bottom-btns{
     text-align: center;
    }
}
.pagination-demo{
  text-align: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/components/threeStep.vue